export const types = {
  FEATURE_LOADING_ERROR:
    'common/viewer/cadViewer/geometricAnalysis/FEATURE_LOADING_ERROR',
  FEATURE_LOADING_REQUEST:
    'common/viewer/cadViewer/geometricAnalysis/FEATURE_LOADING_REQUEST',
  FEATURE_LOADING_SUCCESS:
    'common/viewer/cadViewer/geometricAnalysis/FEATURE_LOADING_SUCCESS',
  FETCH_PART_FILE_GEOMETRIC_ANALYSIS_DATA_ERROR:
    'common/viewer/cadViewer/geometricAnalysis/FETCH_PART_FILE_GEOMETRIC_ANALYSIS_DATA_ERROR',
  FETCH_PART_FILE_GEOMETRIC_ANALYSIS_DATA_INIT:
    'common/viewer/cadViewer/geometricAnalysis/FETCH_PART_FILE_GEOMETRIC_ANALYSIS_DATA_INIT',
  FETCH_PART_FILE_GEOMETRIC_ANALYSIS_DATA_SUCCESS:
    'common/viewer/cadViewer/geometricAnalysis/FETCH_PART_FILE_GEOMETRIC_ANALYSIS_DATA_SUCCESS',
  GEOMETRIC_ANALYSIS_QUEUE_ADD_TO_END:
    'common/viewer/cadViewer/geometricAnalysis/GEOMETRIC_ANALYSIS_QUEUE_ADD_TO_END',
  GEOMETRIC_ANALYSIS_QUEUE_ADD_TO_START:
    'common/viewer/cadViewer/geometricAnalysis/GEOMETRIC_ANALYSIS_QUEUE_ADD_TO_START',
  GEOMETRIC_ANALYSIS_QUEUE_REMOVE:
    'common/viewer/cadViewer/geometricAnalysis/GEOMETRIC_ANALYSIS_QUEUE_REMOVE',
  PART_FILE_GEOMETRIC_ANALYSIS_RECEIVE:
    'common/viewer/cadViewer/geometricAnalysis/PART_FILE_GEOMETRIC_ANALYSIS_RECEIVE',
  BULK_GEOMETRIC_ANALYSIS_RECEIVE:
    'common/viewer/cadViewer/geometricAnalysis/BULK_GEOMETRIC_ANALYSIS_RECEIVE',
};

/*
Actions to manage the on demand loading of feature and feedback item additional viewer content
as the user clicks to request seeing this information
*/
export const featureLoading = {
  request: ({ features, partFileUuid, type }) => ({
    type: types.FEATURE_LOADING_REQUEST,
    payload: { features, partFileUuid, type },
  }),
  success: ({ featureContentsById, type }) => ({
    type: types.FEATURE_LOADING_SUCCESS,
    payload: { featureContentsById, type },
  }),
  error: ({ featureIds, type }) => ({
    type: types.FEATURE_LOADING_ERROR,
    payload: { featureIds, type },
  }),
};

export const fetchPartFileGeometricAnalysisData = {
  error: ({ partFileUuid }) => ({
    type: types.FETCH_PART_FILE_GEOMETRIC_ANALYSIS_DATA_ERROR,
    payload: { partFileUuid },
  }),
  init: ({ partFileUuid }) => ({
    type: types.FETCH_PART_FILE_GEOMETRIC_ANALYSIS_DATA_INIT,
    payload: { partFileUuid },
  }),
  success: ({ geometricAnalysisData, partFileUuid }) => ({
    type: types.FETCH_PART_FILE_GEOMETRIC_ANALYSIS_DATA_SUCCESS,
    payload: {
      geometricAnalysisData,
      partFileUuid,
    },
  }),
};

export const geometricAnalysisQueue = {
  addToEnd: ({ partFileUuid }) => ({
    type: types.GEOMETRIC_ANALYSIS_QUEUE_ADD_TO_END,
    payload: { partFileUuid },
  }),
  addToStart: ({ partFileUuid }) => ({
    type: types.GEOMETRIC_ANALYSIS_QUEUE_ADD_TO_START,
    payload: { partFileUuid },
  }),
  remove: ({ partFileUuid }) => ({
    type: types.GEOMETRIC_ANALYSIS_QUEUE_REMOVE,
    payload: { partFileUuid },
  }),
};

export const bulkGeometricAnalysis = {
  receive: ({ partFileUuids }) => ({
    type: types.BULK_GEOMETRIC_ANALYSIS_RECEIVE,
    payload: { partFileUuids },
  }),
};

export const partFileGeometricAnalysis = {
  receive: ({ geometricAnalysisData, partFileUuid }) => ({
    type: types.PART_FILE_GEOMETRIC_ANALYSIS_RECEIVE,
    payload: { geometricAnalysisData, partFileUuid },
  }),
};
